import React, { useState } from 'react';

import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PersonalInfoForm = ({ formData, onUpdate, onNext }) => {
  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    onUpdate({ [field]: value });
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.fullName?.trim()) newErrors.fullName = 'Full name is required';
    if (!formData.email?.trim()) newErrors.email = 'Email is required';
    if (!formData.phone?.trim()) newErrors.phone = 'Phone number is required';

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (formData.phone && !/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone)) {
      newErrors.phone = 'Please enter phone in format: (123) 456-7890';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      onNext();
    }
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    handleInputChange('phone', formatted);
  };

  return (
    <div className="space-y-8">
      <div>
        <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
          Personal Information
        </h3>
        <p className="text-text-secondary font-caption mb-6">
          Tell us about yourself to personalize your wedding planning experience
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Full Name *
            </label>
            <Input
              type="text"
              placeholder="Enter your full name"
              value={formData.fullName || ''}
              onChange={(e) => handleInputChange('fullName', e.target.value)}
              className={errors.fullName ? 'border-error' : ''}
            />
            {errors.fullName && (
              <p className="text-error text-sm font-caption mt-1">{errors.fullName}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Partner's Name (Optional)
            </label>
            <Input
              type="text"
              placeholder="Enter your partner's name"
              value={formData.partnerName || ''}
              onChange={(e) => handleInputChange('partnerName', e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Email Address *
            </label>
            <Input
              type="email"
              placeholder="your@email.com"
              value={formData.email || ''}
              onChange={(e) => handleInputChange('email', e.target.value)}
              className={errors.email ? 'border-error' : ''}
            />
            {errors.email && (
              <p className="text-error text-sm font-caption mt-1">{errors.email}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Phone Number *
            </label>
            <Input
              type="tel"
              placeholder="(123) 456-7890"
              value={formData.phone || ''}
              onChange={handlePhoneChange}
              className={errors.phone ? 'border-error' : ''}
            />
            {errors.phone && (
              <p className="text-error text-sm font-caption mt-1">{errors.phone}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Referral Code (Optional)
            </label>
            <input
              type="text"
              placeholder="Enter referral code if you have one"
              value={formData.referralCode || ''}
              onChange={(e) => handleInputChange('referralCode', e.target.value.toUpperCase())}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
            />
            <p className="text-text-muted text-xs mt-1">
              Get $25 off when using a friend's referral code
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              How did you hear about us? (Optional)
            </label>
            <select
              value={formData.referralSource || ''}
              onChange={(e) => handleInputChange('referralSource', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
            >
              <option value="">Select one</option>
              <option value="google">Google Search</option>
              <option value="social">Social Media</option>
              <option value="friend">Friend/Family Referral</option>
              <option value="venue">Wedding Venue</option>
              <option value="other-vendor">Other Vendor</option>
              <option value="advertisement">Advertisement</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-6 border-t border-border">
        <Button
          variant="primary"
          size="lg"
          onClick={handleNext}
          iconName="ArrowRight"
          iconPosition="right"
          iconSize={18}
        >
          Continue to Wedding Details
        </Button>
      </div>
    </div>
  );
};

export default PersonalInfoForm;